import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getIsUserImpersonating } from "@faire/help-center-utils/serialized-data/getIsUserImpersonating";
import { getLocaleId } from "@faire/help-center-utils/serialized-data/getLocale";
import {
  getRetailer,
  getRetailerToken,
} from "@faire/help-center-utils/serialized-data/getRetailer";
import {
  getUser,
  getUserEmail,
  getUserToken,
} from "@faire/help-center-utils/serialized-data/getUser";

import { IChatbotMetadata } from "./types";

export const useChatbotStaticMetadata = (): IChatbotMetadata => {
  const retailer = getRetailer();
  const brand = getBrand();
  const businessName = retailer?.name ?? brand?.name;
  const brandEmail = brand?.email_address;
  const retailerEmail = retailer?.email_address;
  const firstName = getUser()?.first_name;
  const lastName = getUser()?.last_name;
  const userEmail = getUserEmail();
  const userType = getRetailerToken() ? "retailer" : "brand";
  const locale = getLocaleId(); // fr_FR for example
  const userImpersonated = getIsUserImpersonating();

  return {
    user_token: getUserToken() ?? "",
    first_name: firstName ?? "",
    last_name: lastName ?? "",
    email: userEmail,
    retailer_token: retailer?.token,
    brand_token: brand?.token,
    business_name: businessName,
    retailer_email: retailerEmail,
    brand_email: brandEmail,
    user_type: userType,
    locale: locale ?? "",
    user_impersonated: userImpersonated,
  };
};
